export default {
  'Welcome!': 'Velkommen!',
  'Joint ID': 'Database-id',
  'Skarv-ID': 'Samle-ID',
  'Database ID': 'Database-id',
  'Sub Contractor': 'Underleverandør',
  'Customer users': 'Kundens brugere',
  'Add user to this customer': 'Tilføj bruger til denne kunde',
  'Failed to save new user': 'Kunne ikke gemme ny bruger',
  'Export to Excel': 'Eksportér til Excel',
  'Failed to export Excel': 'Kunne ikke eksportere til Excel',
  'End date is required': 'Slutdato er påkrævet',
  'Please fill in all required fields': 'Udfyld venligst alle påkrævede felter',
  'Bulk article': 'Bulkvarer',
  'Search by article number or name': 'Søg på varenummer eller navn',
  'No matches': 'Ingen resultater',
  'Search for articles to add. Selected articles will appear here.': 'Søg efter varer at tilføje. Valgte varer vises her.',
  'Add selected': 'Tilføj valgte',
  'Qty': 'Antal',
  'No articles selected': 'Ingen varer valgt',
  '{0} articles selected': '{0} varer valgt',
  'Added {0} articles': '{0} varer tilføjet',
  'Failed to add some articles': 'Kunne ikke tilføje alle varer',
  'Stock After': 'Lagerbeholdning efter',
  'Audit': 'Optælling',
  'Show chart': 'Vis diagram',
  'Hide chart': 'Skjul diagram',
  'No data to chart': 'Ingen data at vise',
  'Joint Log': 'Svejserapport',
  'Home': 'Hjem',
  'ID': 'ID',
  'Reminder': 'Påmindelse/Notits',
  'Reminder: ': 'Påmindelse: ',
  'Alarm': 'Alarm',
  'temps': 'Temperaturer °C',
  'Temperature': 'Temperatur',
  'Joints': 'Samlinger',
  'Select welds': 'Vælg svejsninger',
  'Current Report': 'Valgte rapportlinjer',
  'Current Equipment': 'Nuværende lejet udstyr',
  'Joints welded over time': 'Antal svejsede samlinger over tid',
  'Equipment': 'Udstyr',
  ' Equipment': 'Udstyr',
  'Timestamp': 'Tidsstempel',
  'timestamp': 'Tidsstempel',
  'Welds': 'Svejsninger',
  'Actions': 'Handlinger',
  'Report Preview': 'Forhåndsvisning',
  'Page:': 'Side:',
  'Filters': 'Filtre',
  'Print Stock List': 'Udskriv lagerliste',
  'Barcode': 'Stregkode',
  'Failed to generate stock list': 'Kunne ikke generere lagerliste',
  'This Week': 'Denne uge',
  'This Month': 'Denne måned',
  'This Year': 'I år',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Januar_Februar_Marts_April_Maj_Juni_Juli_August_September_Oktober_November_December',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Ma_Ti_On_To_Fr_Lø_Sø',
  'Previous': 'Forrige',
  'Reloading data..': 'Opdaterer tabellen..',
  'Data reloaded': 'Tabellen opdateret',
  'Add to report': 'Tilføj til rapport',
  'Next': 'Næste',
  'Rental Start Date': 'Startdato lejeperiode',
  'Rental End Date': 'Slutdato lejeperiode',
  'Map': 'Kort',
  'Show map': 'Vis kort',
  'Hide map': 'Skjul kort',
  'Showing the latest 1000 welds.': 'Viser de seneste 1000 svejsninger.',
  'Use filters to narrow down results.': 'Brug filtre for at indsnævre resultaterne.',
  'Password': 'Adgangskode',
  'The password is required!': 'Indtast venligst adgangskode!',
  'Password must be at least {1} characters': 'Adgangskoden skal være mindst {1} tegn',
  'Create User': 'Opret bruger',
  'First Name': 'Fornavn',
  'Last Name': 'Efternavn',
  'E-mail': 'E-mail',
  'User list': 'Brugere',
  'Create new user': 'Opret ny bruger',
  'Edit': 'Rediger',
  'Delete': 'Slet',
  'Delete Image': 'Slet billede',
  'Confirm Delete': 'Bekræft sletning',
  'Are you sure you want to delete this image?': 'Er du sikker på, at du vil slette dette billede?',
  'This action cannot be undone.': 'Denne handling kan ikke fortrydes.',
  'User Profile': 'Brugerprofil',
  'Save': 'Gem',
  'User Companies': 'Virksomhedsadgang',
  'Select companies': 'Vælg virksomheder',
  'Save Companies': 'Gem virksomheder',
  'Welding Report': 'Svejserapport',
  'Welding Machine': 'Svejsemaskine',
  'Welding Machines': 'Svejsemaskiner',
  'Created by:': 'Oprettet af:',
  'Company:': 'Virksomhed:',
  'of': 'af',
  'Remove': 'Slet',
  'Clear Report': 'Ryd alt',
  'Preview Report': 'Forhåndsvisning',
  'Print Report': 'Udskriv',
  'Download PDF': 'Download PDF',
  'Failed to generate PDF': 'Kunne ikke oprette PDF',
  'Are you sure?': 'Er du sikker?',
  'Delete work order?': 'Slet arbejdsordre?',
  'This will permanently delete the work order including all order rows and attached risk reports.': 'Dette vil permanent slette arbejdsordren inklusive alle ordrelinjer og vedhæftede risikorapporter.',
  'Sign In to your account': 'Log ind nedenfor for at få adgang til MittLog-portalen.',
  'Email': 'E-mail',
  'Forgot password?': 'Glemt adgangskode?',
  'Logging in..': 'Logger ind..',
  'Access Denied': 'Login mislykkedes',
  'Map (Only shows welding machines)': 'Kort (viser kun svejsemaskiner)',
  'All': 'Alle',
  'Machine ID': 'Maskine-ID',
  'icon-110': 'icon-power',
  'Ongoing': 'Igangværende',
  'Historical equipment rentals': 'Tidligere lejet udstyr',
  'On': 'Til',
  'Off': 'Fra',
  'Equipment ID (If applicable)': 'Udstyrs-ID (hvis relevant)',
  'Description': 'Beskrivelse',
  'Write a description of what happened..': 'Skriv en beskrivelse af, hvad der skete..',
  'Alert customer to send back equipment': 'Bed kunden om at sende udstyret tilbage',
  'Date': 'Dato',
  'Reason': 'Årsag',
  'Created by': 'Oprettet af',
  'Customer Log': 'Kundelog',
  'Create Log Entry': 'Opret logpost',
  'Support - Phone': 'Support - Telefon',
  'Support - E-mail': 'Support - E-mail',
  'Sales - Phone': 'Salg - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Salgsaktivitet - Kampagne, E-mail mv.',
  'Slug': 'Slug',
  'Subject': 'Emne',
  'Email Templates': 'E-mail-skabeloner',
  'Revision Date': 'Revisionsdato',
  'CPU': 'CPU',
  'Filename 1': 'Filnavn 1',
  'Filename 2': 'Filnavn 2',
  'Revisions': 'Revisioner',
  'Revision': 'Revision',
  'Upload new revision': 'Upload ny revision',
  'Equipment ID': 'Udstyrs-ID',
  '# CPUs': '# CPUer',
  'Create Equipment Specification': 'Opret maskinspecifikation',
  'Display': 'Display',
  'Styrkort': 'Styrekort',
  'Latest rev CPU 1': 'Seneste rev CPU 1',
  'Latest rev CPU 2': 'Seneste rev CPU 2',
  'Equipment Specifications': 'Maskinspecifikation',
  'Create specification': 'Opret specifikation',
  'Old': 'Gammelt',
  'New': 'Nyt',
  'Create Update Entry': 'Opret opdateringsjob',
  'Update Queue': 'Opdateringskø',
  'Create update entry': 'Opret opdateringsjob',
  '[Welcome Title]': 'Velkommen, ',
  '[Welcome Body]': 'Denne portal giver dig indsigt i detaljerne omkring de svejsninger, der udføres i din virksomhed. Brug menuen til venstre for at navigere.',
  'Number of joints': 'Antal samlinger',
  'Dimension': 'Dimension',
  'Select a Machine ID': 'Vælg et maskin-ID',
  'Choose the equipment related to your message (optional)': 'Vælg det udstyr, som henvendelsen vedrører (valgfrit)',
  '-- Nothing Selected --': '-- Intet valgt --',
  'Message': 'Besked',
  'Write your message here': 'Skriv din besked her',
  'I want to send back the equipment': 'Jeg vil sende udstyret tilbage',
  'Contact Support': 'Kontakt support',
  'Send message': 'Send besked',
  'Login': 'Log ind',
  'Logout': 'Log ud',
  'Users': 'Brugere',
  'Firmware Revisions': 'Firmware',
  'Equipment Spec.': 'Maskinspec.',
  'Remote Update': 'Fjernopdatering',
  'Dashboard': 'Oversigt',
  'Current': 'Nuværende',
  'Historical': 'Historik',
  'Weld Report': 'Svejserapport',
  'Weld Report for ': 'Svejserapport for ',
  'Support': 'Support',
  'joint_time_a': 'Samlet svejsetid',
  'u_mains': 'Spænding',
  'u_mains_min_max': 'Min/Max spænding',
  'mode': 'Tilstand',
  'alarm': 'Alarm',
  'channel': 'Kanal',
  'dimension': 'Dimension',
  'name': 'Navn',
  'Report Name:': 'Rapportnavn:',
  'Comment': 'Kommentar',
  'Joint Comment': 'Kommentar',
  'Write a report name.. (optional)': 'Skriv et rapportnavn.. (valgfrit)',
  'Report name:': 'Rapportnavn:',
  'Add all to report': 'Tilføj alle',
  'Per page': 'Antal pr. side',
  'ALARM-0': 'Ingen alarm',
  'ALARM-1': 'Defekt converter',
  'ALARM-2': 'Loghukommelse fuld',
  'ALARM-4': '10 min timeout',
  'ALARM-8': 'Værktøjsproblem',
  'ALARM-16': 'Åbent kabel',
  'ALARM-32': 'Boost timeout',
  'ALARM-64': 'Overophedet',
  'ALARM-128': 'Kortsluttet kabel',
  'TIME-min': 'min',
  'TIME-sec': 'sek',
  'Seconds': 'Sekunder',
  'Minutes': 'Minutter',
  'Select a Dimension': 'Filtrér på dimension',
  'Customer': 'Kunde',
  'Work Order': 'Arbejdsordre',
  'Draft': 'Kladde',
  'New Picklist': 'Ny plukliste',
  'All Picklists': 'Alle pluklister',
  'Title': 'Titel',
  'Start date': 'Startdato',
  'End date': 'Slutdato',
  'Responsible seller': 'Ansvarlig sælger',
  'Street address': 'Vejadresse',
  'Zip code': 'Postnummer',
  'City': 'By',
  'Customer Project/Reference': 'Kundens projekt/ref.',
  'Project Phase': 'Kundens etape',
  'Coil To': 'Sløjfe fremløb',
  'Coil From': 'Sløjfe retur',
  'Coil VV/VVC': 'Sløjfe VV/VVC',
  'Pipe manufacturer': 'Rørproducent',
  'Base city': 'Baseby',
  'Isolation To': 'Isolering fremløb',
  'Isolation From': 'Isolering retur',
  'Discrepancy report': 'Afvigelsesrapport',
  'Density test': 'Tæthedsprøvning',
  'Temp outside': 'Temp ude',
  'Coil Twin': 'Sløjfe twin',
  'Isolation Twin': 'Isolering twin',
  'Alarm connected': 'Alarm tilsluttet',
  'Had blueprint': 'Alarmtegning fandtes',
  'Work description': 'Arbejdsbeskrivelse',
  'Work done by': 'Arbejdet udført af',
  'Work orders': 'Arbejdsordrer',
  'Contact': 'Kontakt',
  'Back': 'Tilbage',
  'Print': 'Udskriv',
  'Articles': 'Varer',
  'Created': 'Oprettet',
  'Update': 'Opdater',
  'Article': 'Vare',
  'Quantity': 'Antal',
  'Quantity missing': 'Antal mangler',
  'Unit': 'Enhed',
  'Work Orders': 'Arbejdsordrer',
  'New Work Order': 'Ny arbejdsordre',
  'View my work orders': 'Mine arbejdsordrer',
  'All Orders': 'Alle',
  'Job Reporting': 'Jobrapportering',
  'Create new work order': 'Opret ny arbejdsordre',
  'bend': 'bøj',
  'Person': 'Person',
  'MSI': 'MSI',
  'Information': 'Information',
  'Work Order List': 'Arbejdsordrer',
  'All work orders': 'Alle arbejdsordrer',
  'Mine': 'Mine ordrer',
  'My work orders': 'Mine arbejdsordrer',
  'Ready for invoicing': 'Klar til fakturering',
  'Info': 'Info',
  'Printed': 'Udskrevne',
  'Not printed': 'Ikke udskrevne',
  'Status': 'Status',
  'Overview': 'Oversigt',
  'Rak': 'Lige',
  'TSC': 'TSC',
  'Krymp': 'Krymp',
  'TSC-Krymp': 'TSC-Krymp',
  'TSC dn': 'TSC Yd',
  'Twin': 'Twin',
  'Gir >3gr': 'Vinkel >3gr',
  'Reduction': 'Reduktion',
  'Incl. sleeve': 'Inkl. muffe',
  'End sleeve': 'Endemuffe',
  'Rep': 'Rep',
  'Protective sleeve': 'Beskyttelsesmuffe',
  'Add': 'Tilføj',
  'T-stycke': 'T-stykke',
  'Single T-Pipe': 'Enkelt T-stykke',
  'Double T-Pipe': 'Dobbelt T-stykke',
  'Stam dn': 'Stamme Yd',
  'Avg dn': 'Afgrening Yd',
  'Lilla dn': 'Lille Yd',
  'Stam red 1 dn': 'Stamme red 1 Yd',
  'Stam red 2 dn': 'Stamme red 2 Yd',
  'Select': 'Vælg',
  'Avgrening 45gr': 'Afgrening 45gr',
  'Avgrening 90gr': 'Afgrening 90gr',
  'Stam Reduction': 'Stammereduktion',
  'Böj': 'Bøjning',
  'Angle up to 45°': 'Bøjning op til 45°',
  'Angle more than 45°': 'Bøjning mere end 45°',
  'Quick add': 'Hurtigvalg',
  'Search articles': 'Søg vare',
  'Select an article': 'Vælg vare',
  'Add article': 'Tilføj vare',
  'Customers': 'Kunder',
  'Admin': 'Admin',
  'Create new article': 'Opret ny vare',
  'Art. No': 'Vare nr.',
  'Default unit': 'Standardenhed',
  'Favorite': 'Favorit',
  'Clear': 'Ryd valg',
  'Set status printed': 'Ændr status til Udskrevet',
  'Set status ready for invoicing': 'Sæt status Klar til fakturering',
  'If you have alarm values, please input them below.': 'Hvis du har alarmværdier, skal de udfyldes nedenfor.',
  'Change password': 'Skift adgangskode',
  'Old password': 'Gammel adgangskode',
  'New password': 'Ny adgangskode',
  'Enter new password again': 'Indtast den nye adgangskode igen',
  'Minimum 6 characters': 'Minimum 6 tegn',
  'Minimum 8 characters': 'Minimum 8 tegn',
  'Reset Password': 'Nulstil adgangskode',
  'Enter your email address': 'Indtast din e-mailadresse',
  'Send reset link': 'Send nulstillingslink',
  'If the email exists, a reset link has been sent.': 'Hvis e-mailen findes registreret, er et nulstillingslink sendt.',
  'Your password has expired. Please set a new password.': 'Din adgangskode er udløbet. Indtast venligst en ny adgangskode.',
  'Confirm password': 'Bekræft adgangskode',
  'Password reset successful. Please log in.': 'Adgangskoden er nulstillet. Log venligst ind.',
  'Invalid or expired reset link.': 'Ugyldigt eller udløbet nulstillingslink.',
  'Password must be at least 8 characters': 'Adgangskoden skal være mindst 8 tegn',
  'Password changed.': 'Adgangskoden er ændret.',
  'Logging in, please wait..': 'Logger ind, vent venligst..',
  'Order responsible': 'Ordreansvarlig',
  'stored': 'Internt ID',
  'Add new rental': 'Ny udlejning',
  'New status': 'Ny status',
  'New customer': 'Ny kunde',
  'Print picklists and set status': 'Udskriv plukliste og skift status',
  'Because the new status is to Service the customer will automatically be set to Mittel :)': 'Da status er Service, sættes kunden automatisk til Mittel',
  'New rental start date': 'Startdato',
  'Cancel': 'Annuller',
  'Rental': 'Udlejning',
  'Create rental': 'Opret udlejning',
  'Search equipment': 'Søg udstyr',
  'Search customer': 'Søg kunde',
  'Ort/Placering': 'By/Placering',
  'Contact person': 'Kundens kontaktperson',
  'Sales responsible': 'Salgsansvarlig',
  'End last rental period': 'Afslut foregående lejeperiode for udstyret',
  'All Rentals': 'Alle udlejninger',
  'Search..': 'Søg..',
  'Type': 'Type',
  'Company': 'Kunde',
  'Ort': 'By',
  'Rentals': 'Udlejninger',
  'Model': 'Model',
  'Model (optional)': 'Model (valgfri)',
  'Equipment Number': 'Udstyrs-ID',
  'Serial no is required': 'Serienummer er påkrævet',
  'Serial must be at least {1} characters': 'Serienummeret skal være mindst {1} tegn',
  'Hidden': 'Skjult',
  'Comment (optional)': 'Kommentar (valgfri)',
  'Create Equipment': 'Opret udstyr',
  'Equipment list': 'Udstyr',
  'Create new equipment': 'Opret nyt udstyr',
  'New Rental': 'Ny udlejning',
  'Equipment Type': 'Udstyrstype',
  'Equipment Model': 'Udstyrsmodel',
  'Remember me': 'Husk mig',
  'First name': 'Fornavn',
  'Last name': 'Efternavn',
  'Phone': 'Telefon',
  'High risk!': 'Høj risiko!',
  'The risk analysis includes a high risk.\n\nTo solve this, either reach out to your contact person at the client or André From, 070-236 88 45.': 'Risikoanalysen indeholder en høj risiko.\n\nFor at afhjælpe risikoen skal du enten kontakte din kontaktperson hos bestilleren eller André From, 070-236 88 45.',
  'WARNING: High risk detected!': 'ADVARSEL: Høj risiko registreret!',
  'The following high-risk issues were identified:': 'Følgende højrisikoproblemer blev identificeret:',
  'Please contact safety coordinator immediately:': 'Kontakt sikkerhedskoordinatoren omgående:',
  'Phone: +46 123 456 789': 'Telefon: +46 123 456 789',
  'Do you still want to create this work order?': 'Vil du stadig oprette denne arbejdsordre?',
  'Only active rentals': 'Kun aktive udlejninger',
  'Only companies with active rentals': 'Kun virksomheder med aktive udlejninger',
  'S-angle': 'S-bøjning',
  'Write a reminder here..': 'Skriv en påmindelse her..',
  'Edit equipment': 'Rediger udstyr',
  'Hide from other parts of portal?': 'Skjul fra andre dele af portalen?',
  'Equipment Types': 'Udstyrstyper',
  'Create new equipment type': 'Opret ny udstyrstype',
  'Create Equipment Type': 'Opret udstyrstype',
  'Type Number (ex. 110)': 'Typenummer (eks. 110)',
  'Type name': 'Typenavn',
  'Create new equipment model': 'Opret ny udstyrsmodel',
  'Equipment Models': 'Udstyrsmodeller',
  'Create Equipment Model': 'Opret udstyrsmodel',
  'Model name': 'Modelnavn',
  'Name': 'Navn',
  'Edit Equipment Model': 'Rediger udstyrsmodel',
  'Create New Work Order': 'Opret ny arbejdsordre',
  'Latest audit': 'Optælling i år',
  ' Mark as audited': ' Markér som optalt',
  'STOCK_AUDIT': 'Optælling',
  'GENERAL_COMMENT': 'Bemærkning',
  'Equipment Comment Log': 'Udstyrslog',
  'Add comment for equipment: ': 'Tilføj kommentar for udstyr: ',
  'FoamCalc': 'SkumCalc',
  'Density mix': 'Densitet mix (uskummet)',
  'Calculate empty volume': 'Beregn tom volumen',
  'Density': 'Densitet',
  'Weld type': 'Samlingstype',
  'ISO:Poly Volume Ratio': 'ISO:Poly volumenforhold',
  'Plastic (mm)': 'Plast (mm)',
  'Steel (mm)': 'Stål (mm)',
  'Length (cm)': 'Længde (cm)',
  'Shortcuts': 'Genveje',
  'Temporary rentals': 'Midlertidige udlejninger',
  'View alert lists': 'Vis alarmliste',
  'Add new contact for customer': 'Tilføj ny kundekontakt',
  'processDone': 'Svejsning fuldført',
  'weld_complete': 'Ja',
  'weld_aborted': 'Nej, afbrudt',
  'weld_unknown': 'Ukendt',
  'Yes': 'Ja',
  'No': 'Nej',
  'Show hidden equipment': 'Vis skjult udstyr',
  'Knowledge Base': 'Vidensbase',
  'Length (default 75m if not specified)': 'Længde (tom = 75m)',
  '1. Choose number of fläta to create and default settings': '1. Angiv antal, længde og intern/ekstern',
  '2. Edit details if needed': '2. Gennemgå/rediger enkelte fletruller',
  'Latest ID:': 'Seneste ID',
  'Quality': 'Kvalitet',
  'Length': 'Længde',
  'Internal': 'Intern',
  'Create': 'Opret',
  'It seems like this work order already exists in BC with order number: ': 'Det ser ud til, at denne arbejdsordre allerede findes i BC med ordrenummer: ',
  'This work order will not be sent to BC again. Please edit the existing work order in BC instead.': 'Arbejdsordren sendes ikke igen. Rediger venligst ordren direkte i BC i stedet.',
  'Stocked date': 'Lagerført',
  'Checkout fläta': 'Tjek flet ud',
  'Add to checkout': 'Tilføj til udtjekning',
  'Color': 'Farve',
  'Sent Date': 'Afsendelsesdato',
  'Nothing selected': 'Intet valgt',
  'Filter by status': 'Filtrér status',
  'Sent by': 'Sendt af',
  'Create work order with article': 'Opret arbejdsordre med varen',
  'Sync BC': 'Synkronisér med BC',
  'New Flata': 'Ny flet',
  'My Profile': 'Min profil',
  'Draft picklists': 'Kladdepluklister',
  'Printed picklists': 'Udskrevne pluklister',
  'Picklists': 'Pluklister',
  'Create New Picklist': 'Opret ny plukliste',
  'Picklist': 'Plukliste',
  'Reference': 'Mærke',
  'Order date': 'Ordredato',
  'Order Contact Person': 'Leveringskontaktperson',
  'Zip Code': 'Postnummer',
  'Shipping address': 'Leveringsadresse',
  'Shipping city': 'Leveringsby',
  'Shipping country': 'Leveringsland',
  'Billing address': 'Faktureringsadresse',
  'Billing city': 'Faktureringsby',
  'Billing country': 'Faktureringsland',
  'Use same address for shipping': 'Brug samme adresse som leveringsadresse',
  'blueprint': 'tegning',
  'Blueprint': 'Tegning',
  'Custom': 'Tilpasset',
  'Name/Company': 'Navn/Virksomhed',
  'Audit Stock': 'Optæl',
  'From ID': 'Fra ID',
  'To ID': 'Til ID',
  'Selected equipment': 'Valgt udstyr',
  'The fields below might be filled in automatically based on the equipment you selected.': 'Felterne nedenfor udfyldes automatisk baseret på det første udstyr, du har valgt.',
  'Warning: There are conflicts in the statuses or rental dates of the selected equipment. Please resolve them before saving.': 'Advarsel: Det valgte udstyr har forskellige statusser, eller den seneste lejeperiode for et udstyr er allerede afsluttet (sidste lejeperiode bør altid være i gang). Korrigér venligst dette separat, før du tjekker flere stykker udstyr ud samtidig.',
  'Use the quick add below to add a standard address to the picklist or leave blank and add your own address.': 'Brug hurtigvalget nedenfor for at tilføje en af de mest almindelige adresser, eller lad feltet være tomt og tilføj din egen adresse.',
  'Fläta Comment Log': 'Optællingslog',
  'Foam Weighing': 'Skumvejning',
  'Upload foam weighing database': 'Upload databasefil',
  'Upload new foam weighing database': 'Upload ny database for skumvejning',
  'Audit all marked': 'Optæl alle markerede',
  'Quick Add Picklist': 'Hurtigvalg plukliste',
  'Quick Add List': 'Hurtigvalg liste',
  'Create new Quick Add': 'Opret nyt hurtigvalg',
  'Shipping Name': 'Leveringsnavn',
  'Street Address': 'Vejadresse',
  'Create Quick Add': 'Opret hurtigvalg',
  'Quick Add Management': 'Hurtigvalgshåndtering',
  'Requested delivery date': 'Ønsket leveringsdato',
  'Weld Overview': 'Oversigt svejsemaskiner',
  'Create picklist with article': 'Opret plukliste med vare',
  'Activate Stock Level': 'Aktivér lagerstyring',
  'Stock List': 'Lageroversigt',
  'Stock': 'Lager',
  'Add Transaction': 'Opret lagertransaktion',
  'Manual Adjustment': 'Manuel justering',
  'User': 'Bruger',
  'ERROR: you need to grant camera access permission': 'FEJL: du skal give tilladelse til kameraadgang',
  'ERROR: no camera on this device': 'FEJL: ingen kamera på denne enhed',
  'ERROR: secure context required (HTTPS, localhost)': 'FEJL: sikker forbindelse påkrævet (HTTPS, localhost)',
  'ERROR: is the camera already in use?': 'FEJL: bruges kameraet allerede?',
  'ERROR: installed cameras are not suitable': 'FEJL: installerede kameraer er ikke egnede',
  'ERROR: Camera error': 'FEJL: Kamerafejl',
  'Please add at least one article with quantity': 'Tilføj mindst én vare med antal',
  'Stock transactions created successfully': 'Lagerændringer blev oprettet',
  'Failed to create stock transactions': 'Kunne ikke oprette lagerændringer',
  'Stock Admin': 'Lageradmin',
  'Stock Checkin': 'Lagerindtjekning',
  'Stock Checkout': 'Lagerudtjekning',
  'New Stock': 'Ny lagerændring',
  'Start Scanning': 'Start scanning',
  'Scan again': 'Scan igen',
  'Quantity exceeds available stock': 'Antallet overstiger tilgængeligt lager',
  'Current stock level': 'Nuværende lagerbeholdning',
  'Article Scanned': 'Vare scannet, vælg antal nedenfor',
  'Article not found or stock management not enabled': 'Vare blev ikke fundet, eller lagerstyring er ikke aktiveret',
  'Remove from Stock': 'Tag ud fra lager',
  'Add to Stock': 'Tilføj til lager',
  'Stock Audit': 'Lageroptælling',
  'Mode': 'Tilstand',
  'Add to Queue': 'Tilføj til kø',
  'Queued Changes': 'Køede ændringer',
  'Current Stock': 'Nuværende lagerbeholdning',
  'New Stock Level': 'Ny lagerbeholdning',
  'Adjustment': 'Justering',
  'Submit AUDIT': 'Opret optælling',
  'Submit IN': 'Tilføj varerne',
  'Submit OUT': 'Tag varerne ud',
  'Submit All Changes': 'Gem alle ændringer',
  'Antal': 'Antal',
  'Stock History': 'Lagerhistorik',
  'History': 'Historik',
  'In Stock': 'Lagerbeholdning',
  'You have unsaved changes. Are you sure you want to go back? All changes will be lost.': 'Du har ikke-gemte ændringer. Er du sikker på, at du vil gå tilbage? Alle ændringer vil gå tabt.',
  'Stock Items': 'Lagervarer',
  'Stock In': 'Indlevering',
  'Stock Out': 'Udtag',
  'Add Stock Transaction': 'Tilføj lagertransaktion',
  'Optional reason for these changes': 'Valgfri årsag til disse ændringer',
  '(Optional)': '(Valgfrit)',
  'What would you like to do?': 'Hvad vil du gøre?',
  'Stock Overview': 'Lageroversigt',
  'Stock Check-in': 'Lagerindlevering',
  'Stock Check-out': 'Lagerudtag',
  'Print Barcodes': 'Udskriv stregkoder',
  'Remove from report': 'Fjern fra rapport',
  'BC Order Number must start with OR followed by numbers': 'BC-ordrenummer skal starte med OR efterfulgt af tal',
  'Utrustning hittades och har automatiskt återaktiverats': 'Udstyr fundet og automatisk genaktiveret fra skjult tilstand',
  'Risk Questions': 'Risikospørgsmål',
  'No Risk': 'Lav',
  'Low Risk': 'Lav',
  'Medium Risk': 'Mellem',
  'High Risk': 'Høj',
  'Yellow': 'Lav',
  'Orange': 'Mellem',
  'Red': 'Høj',
  'Green': 'OK',
  'Show comment/image form': 'Aktivér kommentarfelt og billedupload',
  'Create new risk question': 'Opret nyt risikospørgsmål',
  'Edit risk question': 'Rediger risikospørgsmål',
  'Sort Order': 'Sorteringsrækkefølge',
  'Order': 'Rækkefølge',
  'Enter display order (lower numbers appear first)': 'Angiv visningsrækkefølge (lavere tal vises først)',
  'Deactivate': 'Deaktiver',
  'Activate': 'Aktiver',
  'Are you sure you want to': 'Er du sikker på, at du vil',
  'this risk question?': 'dette risikospørgsmål?',
  'deactivate': 'deaktivere',
  'activate': 'aktivere',
  'Error updating risk question status': 'Fejl ved opdatering af risikospørgsmålets status',
  'Error updating question order': 'Fejl ved opdatering af spørgsmålenes rækkefølge',
  'Question order updated successfully': 'Spørgsmålenes rækkefølge opdateret',
  'Move up': 'Flyt op',
  'Move down': 'Flyt ned',
  'sub-questions': 'underspørgsmål',
  'Hide archived questions': 'Skjul arkiverede spørgsmål',
  'Error loading risk question': 'Fejl ved indlæsning af risikospørgsmål',
  'Error saving risk question': 'Fejl ved lagring af risikospørgsmål',
  'Safe / No risk': 'Sikker / Ingen risiko',
  'Risk identified': 'Risiko identificeret',
  'Question Text': 'Spørgsmålstekst',
  'Enter the risk assessment question': 'Angiv risikovurderingsspørgsmålet',
  'Risk Level': 'Risikoniveau',
  'Optional for neutral questions, required for risk scoring': 'Valgfri for neutrale spørgsmål, påkrævet for risikoscore',
  'No risk level (neutral)': 'Intet risikoniveau (neutral)',
  'Active': 'Aktiv',
  'Archived': 'Arkiveret',
  'Create Risk Question': 'Opret risikospørgsmål',
  'Work Order Details': 'Arbejdsordredetaljer',
  'Risk Assessment': 'Risikovurdering',
  'Creating...': 'Opretter...',
  'Please answer the following risk assessment questions:': 'Besvar venligst følgende risikovurderingsspørgsmål:',
  'Not Applicable': 'Ikke relevant',
  'Additional Comments': 'Yderligere kommentarer',
  'Enter any additional comments about the risk assessment...': 'Angiv eventuelle yderligere kommentarer om risikovurderingen...',
  'Failed to load risk questions': 'Kunne ikke indlæse risikospørgsmål',
  'Error loading risk questions': 'Fejl ved indlæsning af risikospørgsmål',
  'Error loading customers': 'Fejl ved indlæsning af kunder',
  'Error loading customer contacts': 'Fejl ved indlæsning af kundekontakter',
  'Error creating work order': 'Fejl ved oprettelse af arbejdsordre',
  'Risk Reports': 'Risikorapporter',
  'Based on latest report': 'Baseret på seneste rapport',
  'total reports': 'rapporter i alt',
  'read more': 'læs mere',
  'read less': 'læs mindre',
  'No risk reports found for this work order.': 'Ingen risikorapporter fundet for denne arbejdsordre.',
  'Initial Report': 'Oprindelig rapport',
  'Report': 'Rapport',
  'Comments': 'Kommentarer',
  'Risk Assessment Answers': 'Svar på risikovurdering',
  'Question': 'Spørgsmål',
  'Add New Risk Report': 'Tilføj ny risikorapport',
  'Add Risk Report': 'Tilføj risikorapport',
  'Failed to load risk reports': 'Kunne ikke indlæse risikorapporter',
  'Error loading risk reports': 'Fejl ved indlæsning af risikorapporter',
  'Failed to create risk report': 'Kunne ikke oprette risikorapport',
  'Error creating risk report': 'Fejl ved oprettelse af risikorapport',
  'Failed to open print report': 'Kunne ikke åbne udskrift af rapport',
  'Add Admin Images': 'Tilføj adminbilleder',
  'Edit Admin Comment': 'Rediger adminkommentar',
  'Original User Comment': 'Oprindelig brugerkommentar',
  'Original comment (read-only)': 'Oprindelig kommentar (skrivebeskyttet)',
  'Enter admin comment...': 'Angiv adminkommentar...',
  'This comment will be added by admin and preserved alongside the original user comment.': 'Denne kommentar tilføjes af admin og bevares sammen med den oprindelige brugerkommentar.',
  'Edit General Comments': 'Rediger generelle kommentarer',
  'Enter general comments...': 'Angiv generelle kommentarer...',
  'Failed to update comment': 'Kunne ikke opdatere kommentar',
  'Failed to update general comments': 'Kunne ikke opdatere generelle kommentarer',
  'Image': 'Billede',
  'Risk Report': 'Risikorapport',
  'General Comments': 'Generelle kommentarer',
  'Additional Risk Assessment': 'Yderligere risikovurdering',
  'Additional Observations': 'Yderligere observationer',
  'Use this section to document any additional risks not covered by the standard questions above': 'Brug dette afsnit til at dokumentere eventuelle yderligere risici, som ikke er dækket af standardspørgsmålene ovenfor',
  'Is there anything else you would like to report? If so, please describe it and assess the risk level.': 'Er der noget andet, du gerne vil rapportere? I så fald, beskriv det og vurder risikoniveauet.',
  'Description / Comments': 'Beskrivelse / Kommentarer',
  'Describe any additional observations, risks, or concerns...': 'Beskriv eventuelle yderligere observationer, risici eller bekymringer...',
  'You can select multiple images to document your observations': 'Du kan vælge flere billeder for at dokumentere dine observationer',
  'Risk Level Assessment': 'Vurdering af risikoniveau',
  'If you have identified a risk above, please assess its level': 'Hvis du har identificeret en risiko ovenfor, vurder venligst niveauet',
  'No Additional Risk': 'Ingen yderligere risiko',
  'Risk Description': 'Risikobeskrivelse',
  'Describe the identified risk...': 'Beskriv den identificerede risiko...',
  'Edit Additional Risk': 'Rediger yderligere risiko',
  'Edit Additional Observations': 'Rediger yderligere observationer',
  'Add Additional Observations': 'Tilføj yderligere observationer',
  'Failed to update additional risk': 'Kunne ikke opdatere yderligere risiko',
  'Failed to upload images for additional risk. The report will be saved without these images.': 'Kunne ikke uploade billeder for yderligere risiko. Rapporten gemmes uden disse billeder.',
  'Failed to upload images for additional observations. The report will be saved without these images.': 'Kunne ikke uploade billeder for yderligere observationer. Rapporten gemmes uden disse billeder.',
  'Enter any additional general comments...': 'Angiv eventuelle yderligere generelle kommentarer...',
  'Create Work Order': 'Opret arbejdsordre',
  'Mark all as OK': 'Markér alle som OK',
  'Work Order Title': 'Arbejdsordretitel',
  'RED': 'RØD',
  'ORANGE': 'ORANGE',
  'YELLOW': 'GUL',
  'GREEN': 'GRØN',
  'Low': 'Lav',
  'Medium': 'Mellem',
  'High': 'Høj',
  'Enter work order title/name': 'Angiv arbejdsordretitel/navn',
  'Safety requirements to be checked:': 'Sikkerhedskrav, der skal kontrolleres:',
  'All above safety requirements are OK': 'Alle ovenstående sikkerhedskrav er OK',
  'Enter any additional safety comments...': 'Angiv eventuelle yderligere sikkerhedskommentarer...',
  'Add details about this risk...': 'Tilføj detaljer om denne risiko...',
  'Upload Images': 'Upload billeder',
  'Choose images...': 'Vælg billeder...',
  'You can select multiple images': 'Du kan vælge flere billeder',
  'No Risks Identified / All OK': 'Ingen risici identificeret / Alt OK',
  'Add general comments': 'Tilføj generelle kommentarer',
  'High Risk Identified': 'Høj risiko identificeret',
  'Understood': 'Forstået',
  'Images': 'Billeder',
  'Select customer': 'Vælg kunde',
  'Current Status': 'Status',
  'Overall Risk Assessment': 'Nuværende risikovurdering',
  'You have marked a high risk - Please call': 'Du har markeret en høj risiko - Ring venligst',
  'Loading risk questions...': 'Indlæser risikospørgsmål...',
  'Please fill in the work order title': 'Udfyld venligst arbejdsordretitlen',
  'Please complete the risk assessment': 'Gennemfør venligst risikovurderingen',
  'All questions marked as No Risk': 'Alle spørgsmål markeret som Ingen risiko',
  'Failed to create work order': 'Kunne ikke oprette arbejdsordre',
  'You can select multiple images (max 1MB each)': 'Du kan vælge flere billeder (max 1MB pr. stk.)',
  'Images uploaded successfully': 'Billeder uploadet',
  'Failed to upload images': 'Kunne ikke uploade billeder',
  'Loading...': 'Indlæser...',
  'Browse': 'Gennemse',
  'User Images': 'Brugerbilleder',
  'Admin Images': 'Adminbilleder',
  'Add Images': 'Tilføj billeder',
  'Edit Comment': 'Rediger kommentar',
  'User Comment': 'Brugerkommentar',
  'Admin Comment': 'Adminkommentar',
  'Admin Actions': 'Adminhandlinger',
  'Failed to add images': 'Kunne ikke tilføje billeder',
  'Failed to add risk row': 'Kunne ikke tilføje risikorække',
  'Print functionality will be implemented in Task 13': 'Udskriftsfunktionalitet implementeres i Opgave 13',
  'Enter risk question...': 'Angiv risikospørgsmål...',
  'Risk levels determine the severity of identified hazards': 'Risikoniveauer afgør alvorligheden af identificerede farer',
  'Low risk situations': 'Lavrisikosituationer',
  'Medium risk requiring attention': 'Mellemhøj risiko, der kræver opmærksomhed',
  'High risk requiring immediate action': 'Høj risiko, der kræver omgående handling',
  'Confirm Archive': 'Bekræft arkivering',
  'Are you sure you want to archive this risk question?': 'Er du sikker på, at du vil arkivere dette risikospørgsmål?',
  'Archived questions will no longer appear in new risk assessments but will remain visible in historical reports.': 'Arkiverede spørgsmål vises ikke længere i nye risikovurderinger, men forbliver synlige i historiske rapporter.',
  'Error creating risk question': 'Fejl ved oprettelse af risikospørgsmål',
  'Error archiving risk question': 'Fejl ved arkivering af risikospørgsmål',
  'Work Details': 'Arbejdsdetaljer',
  'Complete': 'Afslut',
  'Enter basic work order information': 'Angiv grundlæggende arbejdsordreinformation',
  'Complete safety risk evaluation': 'Gennemfør sikkerhedsrisikovurdering',
  'Complete work order details first': 'Gennemfør arbejdsordredetaljer først',
  'Ready to Create Work Order': 'Klar til at oprette arbejdsordre',
  'All required information has been completed': 'Alle påkrævede oplysninger er udfyldt',
  'Failed to upload image': 'Kunne ikke uploade billede',
  'Failed to process image': 'Kunne ikke behandle billede',
  'Failed to upload images for question': 'Kunne ikke uploade billeder for spørgsmål',
  'The report will be saved without these images.': 'Rapporten gemmes uden disse billeder.',
  'Uploading...': 'Uploader...',
  'Min Stock': 'Min. lager',
  'Not set': 'Ikke angivet',
  'Min stock must be a positive number or empty': 'Min. lager skal være et positivt tal eller tomt',
  'Min stock level updated': 'Min. lagerniveau opdateret',
  'Failed to update min stock level': 'Kunne ikke opdatere min. lagerniveau',
  'Stock enabled for article': 'Lagerstyring aktiveret for vare',
  'Article not found': 'Vare ikke fundet',
  'Steel Pipes': 'Medierør (stål)',
  'Plastic Jackets': 'Kapperør (plast)',
  'Pipe-Jacket Mappings': 'Rør-Kappe koblinger',
  'Nominal diameter (DN)': 'Nominel diameter (DN)',
  'Outside diameter (Dy)': 'Udvendig diameter (Dy)',
  'Wall thickness (s)': 'Vægtykkelse (s)',
  'Outside diameter casing (Dym)': 'Udvendig diameter kappe (Dym)',
  'Outside diameter bend sleeve (Dybm)': 'Udvendig diameter bøjningsmuffe (Dybm)',
  'Wall thickness casing (tm)': 'Vægtykkelse kappe (tm)',
  'Wall thickness bend sleeve (tbm)': 'Vægtykkelse bøjningsmuffe (tbm)',
  'Shrink sleeve (shrink)': 'Krympemuffe (shrink)',
  'Add Steel Pipe': 'Tilføj stålrør',
  'Add Plastic Jacket': 'Tilføj kapperør',
  'Add Mapping': 'Tilføj kobling',
  'Show deleted': 'Vis slettede',
  'Restore': 'Gendan',
  'Serie': 'Serie',
  'Pipes': 'Rør',
  'Single': 'Enkelt',
  'Steel Pipe': 'Stålrør',
  'Plastic Jacket': 'Kapperør',
  'A deleted entry with this dimension exists': 'En slettet post med denne dimension findes allerede',
  'This dimension already exists': 'Denne dimension findes allerede',
  'This mapping already exists': 'Denne kobling findes allerede',
  'A user with this email already exists': 'En bruger med denne e-mailadresse findes allerede',
  'Something went wrong': 'Noget gik galt',
  'A deleted mapping with these values exists': 'En slettet kobling med disse værdier findes allerede',
  'Failed to create entry': 'Kunne ikke oprette post',
  'Failed to delete entry': 'Kunne ikke slette post',
  'Failed to restore entry': 'Kunne ikke gendanne post',
  'Deleted': 'Slettet',
  'Restored': 'Gendannet',
  'Bend Types': 'Bøjningstyper',
  'Bend Type': 'Bøjningstype',
  'Radius (R)': 'Radius (R)',
  'Add Bend Type': 'Tilføj bøjningstype',
  'Welding': 'Svejsning',
  'Insulation': 'Isolering',
  'Inspections': 'Inspektioner',
  'Alarm Connected': 'Alarm tilsluttet',
  'Alarm Tested': 'Alarm testet',
  'Pressure Tested': 'Tryktestet',
  'Visual Inspection': 'Visuel inspektion',
  'Toggle all': 'Skift alle',
  'Approved': 'Godkendt',
  'Rejected': 'Underkendt',
  'Selected joints': 'Valgte samlinger',
  'Clear all': 'Ryd alle',
  'No joints selected': 'Ingen samlinger valgt',
  'Are you sure you want to clear all selected joints?': 'Er du sikker på, at du vil rydde alle valgte samlinger?',
  'My Reports': 'Mine rapporter',
  'My joint reports': 'Mine svejserapporter',
  'Joint Count': 'Antal samlinger',
  'No reports found': 'Ingen rapporter fundet',
  'Report Summary': 'Rapportsammendrag',
  'Total Joints': 'Samlinger i alt',
  'Dimensions': 'Dimensioner',
  'Address': 'Adresse',
  'Orderer': 'Bestiller',
  'Client': 'Bestiller',
  'Stage': 'Etape',
  'Customer Project/Ref': 'Kundeprojekt/Ref',
  'Drawing No.': 'Tegningsnr.',
  'Resistance': 'Modstand',
  'Installer': 'Montør',
  'Address/City': 'Adresse/By',
  'Alarm Supply': 'Alarm fremløb',
  'Alarm Return': 'Alarm retur',
  'Alarm Twin': 'Alarm twin',
  'Isolation Supply': 'Isolering fremløb',
  'Isolation Return': 'Isolering retur',
  'Alarm tested': 'Alarm testet',
  'Pressure tested': 'Tryktestet',
  'Visual inspection': 'Visuel inspektion',
  'Editable dimension': 'Redigerbar dimension',
  'DEV: Fields': 'DEV: Felter',
  'Header fields': 'Hovedfelter',
  'Row fields': 'Rækkefelter',
  'Report field configuration': 'Rapportfeltkonfiguration',
  'Report Information': 'Rapportinformation',
  'Enter report name': 'Angiv rapportnavn',
  'Report Name': 'Rapportnavn',
  'Joint Details': 'Samlingsdetaljer',
  'Review & Print': 'Gennemse & udskriv',
  'No joints selected. Go back to select joints.': 'Ingen samlinger valgt. Gå tilbage for at vælge samlinger.',
  'Add note...': 'Tilføj note...',
  'No temperature data': 'Ingen temperaturdata',
  'Voltage': 'Spænding',
  'Channel': 'Kanal',
  'Weld Time': 'Svejsetid',
  'Coil': 'Sløjfe',
  'Isolation': 'Isolering',
  'To (tillopp)': 'Fremløb',
  'From (retur)': 'Retur',
  'Field Mode': 'Felttilstand',
  'Select or create report': 'Vælg eller opret rapport',
  'Create new report': 'Opret ny rapport',
  'New report name': 'Nyt rapportnavn',
  'Weld ID': 'Samle-ID',
  'Save weld': 'Gem svejsning',
  'Update weld': 'Opdater svejsning',
  'Cancel edit': 'Annuller redigering',
  'Report welds': 'Rapportsvejsninger',
  'Start over': 'Start forfra',
  'Take photo': 'Tag foto',
  'Photo attached': 'Foto vedhæftet',
  'Alarm resistance': 'Sløjfemodstand Ω',
  'Insulation resistance': 'Isoleringsmodstand Ω',
  'Notes': 'Noter',
  'Generating PDF...': 'Genererer PDF...',
  'Remove logo': 'Fjern logo',
  'Customer logo': 'Kundelogo',
  'Are you sure you want to delete this report?': 'Er du sikker på, at du vil slette denne rapport?',
  'Are you sure you want to remove this joint?': 'Er du sikker på, at du vil fjerne denne samling?',
  'Are you sure you want to remove this joint from the report?': 'Er du sikker på, at du vil fjerne denne samling fra rapporten?',
  'Weld saved': 'Svejsning gemt',
  'Weld saved locally': 'Svejsning gemt lokalt',
  'Weld saved but ID not found in database': 'Svejsning gemt, men ID blev ikke fundet i databasen',
  'Failed to sync weld to server': 'Kunne ikke synkronisere svejsning til serveren',
  'Photo uploaded': 'Foto uploadet',
  'Photos': 'Fotos',
  'Retry': 'Prøv igen',
  'Saving...': 'Gemmer...',
  'Edit Report': 'Rediger rapport',
  'Completed': 'Afsluttet',
  'Failed to save report': 'Kunne ikke gemme rapport',
  'Supply': 'Fremløb',
  'Return': 'Retur',
  'New Report': 'Ny rapport',
  'All Reports': 'Alle rapporter',
  'Mark as Printed': 'Markér som udskrevet',
  'Report marked as printed': 'Rapport markeret som udskrevet',
  'All joint reports': 'Alle svejserapporter',
  'Reports': 'Rapporter',
  'Create PDF': 'Opret PDF',
  'Not yet matched to machine data': 'Denne samling blev tilføjet via felttilstand. Der findes endnu ingen matchende data i databasen. Enten har svejsemaskinen ikke synkroniseret sine data endnu, eller også er der angivet et forkert samle-ID.',
  'Match': 'Match',
  'No matching joint found': 'Ingen matchende samling fundet',
  'Multiple matches found': 'Flere matches fundet',
  'Select matching joint': 'Vælg matchende samling',
  'Matched successfully': 'Matchet',
  'Source': 'Kilde',
  'INVALID WELD NO': 'UGYLDIGT SAMLE-NR',
  'English': 'Engelsk',
  'Swedish': 'Svensk',
  'Polish': 'Polsk',
  'Czech': 'Tjekkisk',
  'Danish': 'Dansk',
  'Default language': 'Standardsprog',
  'Resource not found': 'Ressourcen blev ikke fundet',
  'Invalid request': 'Ugyldig anmodning',
  'Something went wrong on our end. Please try again or contact support': 'Noget gik galt hos os. Prøv igen, eller kontakt supporten'
}



// WEBPACK FOOTER //
// ./src/translations/da.js